export default __webpack_public_path__ + "static/media/logo.aa746acd.svg";